import React from 'react';
import './checkout.scss';
import SecondaryNav from '../../components/mweb/SecondaryNav/SecondaryNav';
import Addresses from '../../components/mweb/Address/Addresses';
import {
  subscriptionPrefix,
  getSubscriptionRoute,
} from '../../components/mweb/Subscription/subscription.routes';

class AddressList extends React.Component {
  constructor(props) {
    super(props);
    this.source = 'checkout';
    if (this.props.match.path === getSubscriptionRoute('addressList')) {
      this.source = subscriptionPrefix;
    }
  }

  render() {
    return (
      <div className="address-list">
        <SecondaryNav
          showCart={false}
          showSearch={false}
          title="Select Address"
          capitalize
        />
        <Addresses source={this.source} />
      </div>
    );
  }
}

export default AddressList;
